import { type ReactNode } from 'react'
import { MsalProvider } from '@azure/msal-react'
import { isEntraConfigured } from './msalConfig'
import { msalInstance } from './msalInstance'

interface AuthProviderProps {
  children: ReactNode
}

// AuthProvider wraps the app with MSAL context when Entra is configured
// Falls back to just rendering children when not configured (API key mode)
export function AuthProvider({ children }: AuthProviderProps) {
  if (!isEntraConfigured() || !msalInstance) {
    // Entra not configured - app will use API key authentication
    return <>{children}</>
  }

  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  )
}
